
import React from "react";
import { Loader2, User } from "lucide-react";

interface ProfileHeaderProps {
  loading: boolean;
}

export const ProfileHeader = ({ loading }: ProfileHeaderProps) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 text-[#00B6F0] animate-spin" />
      </div>
    );
  }
  
  return (
    <div className="space-y-2">
      <h2 className="text-2xl font-bold text-white">Perfil e Configurações</h2>
      <p className="text-gray-400">
        Gerencie suas informações pessoais e como elas aparecem na plataforma.
      </p>
    </div>
  );
};
